import { render, staticRenderFns } from "./EDSHome.vue?vue&type=template&id=1e742d8e&"
import script from "./EDSHome.vue?vue&type=script&lang=js&"
export * from "./EDSHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports